"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function getContent(data) {
  return data.content;
}

exports.getContent = getContent;

function checkSameContent(label1, label2) {
  return getContent(label1) === getContent(label2);
}

exports.checkSameContent = checkSameContent;

function create(labelTxt) {
  return {
    content: labelTxt
  };
}

exports.create = create;